import ExcelJS from 'exceljs';

/*
  Template Excel Import
  Kolom:
  tanggal | sumber | akun : subakun | nominal | catatan
*/

export async function formBulk(
  jenis,
  authIdentity = {},
  opsiCabang = [],
  opsiSumber = [],
  opsiSubAkun = []
) {

  const workbook = new ExcelJS.Workbook();

  // ==============================
  // SHEET UTAMA
  // ==============================

  const worksheet = workbook.addWorksheet(
    String(authIdentity?.kode_cabang || '').trim() === 'C-1'
    ? 'Bulk Multi Cabang'
    : `Bulk Cabang ${String(authIdentity?.nama_cabang || authIdentity?.kode_cabang || '').trim()}`
  );

  if(String(authIdentity?.kode_cabang || '').trim() === 'C-1') {  
  
  worksheet.columns = [
    { header: 'tanggal', key: 'tanggal', width: 15 },
    { header: 'cabang', key: 'cabang', width: 20 },
    { header: 'sumber', key: 'sumber', width: 20 },
    { header: 'akun : subakun', key: 'subakun', width: 40 },
    { header: 'nominal', key: 'nominal', width: 18 },
    { header: 'catatan', key: 'catatan', width: 40 },
  ]} 
  else {
  
    worksheet.columns = [
    { header: 'tanggal', key: 'tanggal', width: 15 },
    { header: 'sumber', key: 'sumber', width: 20 },
    { header: 'akun : subakun', key: 'subakun', width: 40 },
    { header: 'nominal', key: 'nominal', width: 18 },
    { header: 'catatan', key: 'catatan', width: 40 },
  ]};

  // Freeze header
  worksheet.views = [{ state: 'frozen', ySplit: 1 }];

  // ==============================
  // STYLE HEADER (KUNING)
  // ==============================
  const headerRow = worksheet.getRow(1);

  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFFF2CC' } // kuning soft
  };

  headerRow.eachCell((cell) => {
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // ==============================
  // SHEET ENUM (HIDDEN)
  // ==============================
  const listSheet = workbook.addWorksheet('LIST_OPSI');
  
  const opsiCab = opsiCabang.map(x => x.nama_cabang); 
  const opsiSumberValues = [...new Set(
    (Array.isArray(opsiSumber) ? opsiSumber : [])
      .map((item) => {
        if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
        if (item && typeof item === 'object') return String(item.sumber ?? '').trim();
        return '';
      })
      .filter(Boolean)
  )];

  opsiCab.forEach((val, i) => {
    listSheet.getCell(`B${i + 1}`).value = val;
  });

  opsiSumberValues.forEach((val, i) => {
    listSheet.getCell(`C${i + 1}`).value = val;
  });
  
  const opsiSubAkun_Pusat = [ 'PUSAT : DROPPING' ];
  
  const sorted = [...opsiSubAkun].sort((a, b) =>
    a.localeCompare(b, 'id', { sensitivity: 'base' })
  );

  if(jenis === 'drp' || jenis === 'kdr' ) {
    opsiSubAkun_Pusat.forEach((val, i) => 
    listSheet.getCell(`D${i + 1}`).value = val);
  }
  else{
    sorted.forEach((val, i) => 
    listSheet.getCell(`D${i + 1}`).value = val);
  };

  listSheet.state = 'hidden';

  // ==============================
  // VALIDASI TANGGAL
  // ==============================
  const today = new Date();
  const minDate = new Date();
  minDate.setMonth(today.getMonth() - 1);

  const formatDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;

  const minDateStr = formatDate(minDate);
  const maxDateStr = formatDate(today);

  // ==============================
  // VALIDASI UNTUK 1000 BARIS
  // ==============================

  
  if(String(authIdentity?.kode_cabang || '').trim() === 'C-1') {  
  //VALIDASI PUSAT (DROPPING DAN KOREKSI DROPPING)  
  for (let i = 2; i <= 1001; i++) {

    // TANGGAL
    worksheet.getCell(`A${i}`).dataValidation = {
      type: 'date',
      operator: 'between',
      allowBlank: true,
      formulae: [minDateStr, maxDateStr],
      showErrorMessage: true,
      errorTitle: 'Tanggal tidak valid',
      error: `Tanggal valid sampai dengan 1 bulan terakhir.`
    };

    // CABANG (ENUM)
    worksheet.getCell(`B${i}`).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`LIST_OPSI!$B$1:$B$${opsiCabang.length}`]
    };
    
    // SUMBER (ENUM)
    worksheet.getCell(`C${i}`).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`LIST_OPSI!$C$1:$C$${opsiSumberValues.length}`]
    };

    // SUBAKUN (ENUM)
    worksheet.getCell(`D${i}`).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`LIST_OPSI!$D$1:$D$${opsiSubAkun.length}`]
    };

    // NOMINAL (ANGKA > 0)
    worksheet.getCell(`E${i}`).dataValidation = {
      type: 'decimal',
      operator: 'greaterThan',
      allowBlank: true,
      formulae: [0],
      showErrorMessage: true,
      errorTitle: 'Nominal tidak valid',
      error: 'Nominal harus berupa angka lebih dari 0'
    };

    // Format ribuan
    worksheet.getCell(`E${i}`).numFmt = '#,##0';

    // CATATAN (MAX 100 KARAKTER)
    worksheet.getCell(`F${i}`).dataValidation = {
      type: 'textLength',
      operator: 'lessThanOrEqual',
      allowBlank: true,
      formulae: [100],
      showErrorMessage: true,
      errorTitle: 'Catatan terlalu panjang',
      error: 'Maksimal 100 karakter'
    };
  }} 
  else {
  for (let i = 2; i <= 1001; i++) {

    // TANGGAL
    worksheet.getCell(`A${i}`).dataValidation = {
      type: 'date',
      operator: 'between',
      allowBlank: true,
      formulae: [minDateStr, maxDateStr],
      showErrorMessage: true,
      errorTitle: 'Tanggal tidak valid',
      error: `Tanggal valid sampai dengan 1 bulan terakhir.`
    };

    // SUMBER (ENUM)
    worksheet.getCell(`B${i}`).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`LIST_OPSI!$C$1:$C$${opsiSumberValues.length}`]
    };

    // SUBAKUN (ENUM)
    worksheet.getCell(`C${i}`).dataValidation = {
      type: 'list',
      allowBlank: true,
      formulae: [`LIST_OPSI!$D$1:$D$${opsiSubAkun.length}`]
    };

    // NOMINAL (ANGKA > 0)
    worksheet.getCell(`D${i}`).dataValidation = {
      type: 'decimal',
      operator: 'greaterThan',
      allowBlank: true,
      formulae: [0],
      showErrorMessage: true,
      errorTitle: 'Nominal tidak valid',
      error: 'Nominal harus berupa angka lebih dari 0'
    };

    // Format ribuan
    worksheet.getCell(`D${i}`).numFmt = '#,##0';

    // CATATAN (MAX 100 KARAKTER)
    worksheet.getCell(`E${i}`).dataValidation = {
      type: 'textLength',
      operator: 'lessThanOrEqual',
      allowBlank: true,
      formulae: [100],
      showErrorMessage: true,
      errorTitle: 'Catatan terlalu panjang',
      error: 'Maksimal 100 karakter'
    };
  }}

  // ==============================
  // DOWNLOAD FILE
  // ==============================
  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob(
    [buffer],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  );

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'template_import.xlsx';
  a.click();
  URL.revokeObjectURL(url);
}
